import { breakpoints, pxToCssFont, pxToRem } from '@vfit/shared/themes';
import styled from 'styled-components';
import * as E from '../../editorialCard.style';

export const Date = styled(E.Street)`
  margin: ${pxToRem(0, 0, 24)};
`;

export const Description = styled.div`
  ${pxToCssFont(20, 26)};
  margin: ${pxToRem(24, 0, 0)};

  @media (min-width: ${breakpoints.desktop}) {
    ${pxToCssFont(20, 30)};
  }
`;

